export const toSlug = (str) => {
  return str
    .toLowerCase()
    // Replace spaces and special chars with dashes
    .replace(/[^a-z0-9]+/g, '-')
    // Remove leading/trailing dashes
    .replace(/^-+|-+$/g, '');
}; 